import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
// import { Link } from 'react-router';
import styled from 'styled-components';

import NavigateNext from 'material-ui/svg-icons/image/navigate-next';

import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import AnimatedIcon from 'material-ui/svg-icons/av/movie';

import IconPlayer from 'material-ui/svg-icons/social/person';
import IconPeople from 'material-ui/svg-icons/social/people-outline';
import IconTeam from 'material-ui/svg-icons/social/group';
import IconTourn from 'material-ui/svg-icons/editor/highlight';
import IconMatch from 'material-ui/svg-icons/action/toll';
// import IconMore from 'material-ui/svg-icons/navigation/more-horiz';
import IconTransfers from 'material-ui/svg-icons/action/compare-arrows';

import IconF1 from 'material-ui/svg-icons/maps/directions-car';
import IconOther from 'material-ui/svg-icons/action/view-carousel';

import IconWidget from 'material-ui/svg-icons/action/code';
import Casino from 'material-ui/svg-icons/places/casino';
import TouchApp from 'material-ui/svg-icons/action/touch-app';

const Wrapper = styled.div`
    position: relative;
`;

// const Label = styled.p`
//     margin: 0;
//     padding: 16px 0;
//     color: #000;
//     cursor: pointer;
// `;

const CATEGORIES = {
    ANIMATED: {
        name: 'Animated widgets',
        key: 'animated',
        leftIcon: <AnimatedIcon />,
    },
    TOURNAMENTS: {
        name: 'Tournament widgets',
        key: 'tournaments',
        leftIcon: <IconTourn />,
    },
    // PRO_TOURNAMENTS: {
    //     name: 'PRO Tournament widgets',
    //     key: 'pro_tournaments',
    //     leftIcon: (
    //         <rmd.Badge
    //             badgeContent="P"
    //             style={{ padding: 0 }}
    //             secondary
    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
    //         >
    //             <IconTourn />
    //         </rmd.Badge>
    //     ),
    // },
    EVENTS: {
        name: 'Match widgets',
        key: 'events',
        leftIcon: <IconMatch />,
    },
    // PRO_EVENTS: {
    //     name: 'PRO Match widgets',
    //     key: 'pro_events',
    //     leftIcon: (
    //         <rmd.Badge
    //             badgeContent="P"
    //             style={{ padding: 0 }}
    //             secondary
    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
    //         >
    //             <IconMatch />
    //         </rmd.Badge>
    //     ),
    // },
    TEAM: {
        name: 'Club widgets',
        key: 'teams',
        leftIcon: <IconTeam />,
    },
    // PRO_TEAM: {
    //     name: 'PRO club widgets',
    //     key: 'pro_teams',
    //     leftIcon: (
    //         <rmd.Badge
    //             badgeContent="P"
    //             style={{ padding: 0 }}
    //             secondary
    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
    //         >
    //             <IconTeam />
    //         </rmd.Badge>
    //     ),
    // },
    PLAYER_PROFILE: {
        name: 'Player widgets',
        key: 'players',
        leftIcon: <IconPlayer />,
    },
    H2H: {
        name: 'Player vs Player',
        key: 'player_h2h',
        leftIcon: <IconPeople />,
    },
    // PRO_PLAYER_PROFILE: {
    //     name: 'PRO player widgets',
    //     key: 'pro_players',
    //     leftIcon: (
    //         <rmd.Badge
    //             badgeContent="P"
    //             style={{ padding: 0 }}
    //             secondary
    //             badgeStyle={{ fontSize: 12, width: 16, height: 16, top: -6, right: -6 }}
    //         >
    //             <IconPlayer />
    //         </rmd.Badge>
    //     ),
    // },
    ODDS_BOOSTER: {
        name: 'Odds Booster widgets',
        key: 'odds_booster',
        leftIcon: <Casino />,
    },
    INTERACTIVE: {
        name: 'Interactive widgets',
        key: 'interactive',
        leftIcon: <TouchApp />,
    },
    F1: {
        name: 'Formula 1',
        key: 'f1',
        leftIcon: <IconF1 />,
    },
    TRANSFERS: {
        name: 'Transfers',
        key: 'transfers',
        leftIcon: <IconTransfers />,
    },
    LINEUPS: {
        name: 'Soccer Lineup',
        key: 'lineups',
        leftIcon: <IconOther />,
    },
    OTHER: {
        name: 'Others',
        key: 'others',
        leftIcon: <IconOther />,
    },
};

const groupWidgets = widgets => {
    const socialWidgets = _.filter(widgets, w => w.spec.categories && w.spec.categories.length);

    const categories = Object.values(CATEGORIES);

    _.each(socialWidgets, w => {
        const cats = (w.spec && w.spec.categories) || [];
        _.chain(cats)
            .map(catKey => _.find(categories, c => c.key === catKey))
            .compact()
            .each(c => {
                c.widgets = c.widgets || [];
                c.widgets.push(w);
            })
            .value();

        // if no, add to others
        if (cats.length === 0) {
            const cat = _.find(categories, c => c.key === CATEGORIES.OTHER.key);
            cat.widgets = cat.widgets || [];
            cat.widgets.push(w);
        }
    });

    const prepearedCategories = categories.map(cat => {
        if (cat.widgets) {
            const withSub = cat.widgets.filter(c => c.spec.widgetGroup);
            const withoutSub = cat.widgets.filter(c => !c.spec.widgetGroup);

            cat.widgets = withoutSub;
            if (withSub.length) {
                cat.subWidgets = _.groupBy(withSub, s => s.spec.widgetGroup);
            }
        }

        return cat;
    });

    return prepearedCategories;
};

class WidgetNestedMenu extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            widgets: groupWidgets(props.widgets),
            opened: false,
        };
    }

    renderLabel() {
        const { widgetId, widgets, title } = this.props;
        const widget = _.find(widgets, w => w.id === widgetId);
        const labelTitle = title ? title : 'Select a widget';

        return (
            <rmd.FlatButton
                icon={<IconWidget />}
                label={widget ? widget.name : labelTitle}
                onClick={e => {
                    this.setState({ anchorEl: e.target, opened: true });
                }}
            />
        );
    }

    renderMenu() {
        const { widgets } = this.props;

        return (
            <rmd.Popover
                open={this.state.opened}
                anchorEl={this.state.anchorEl}
                autoCloseWhenOffScreen
                useLayerForClickAway
                onRequestClose={() => this.setState({ opened: false })}
            >
                <rmd.Menu>
                    {widgets.map(widget => {
                        if (widget && widget.spec.noCategories) {
                            return (
                                <rmd.MenuItem
                                    key={widget.id}
                                    primaryText={widget.name}
                                    leftIcon={<NavigateNext />}
                                    onClick={e => {
                                        if (this.props.onChange) this.props.onChange(e, widget);
                                        this.setState({ opened: false });
                                    }}
                                />
                            );
                        }

                        return null;
                    })}

                    {this.state.widgets.map(category => {
                        if (category.widgets && category.widgets.length > 0) {
                            const subWidgets = category.subWidgets ? Object.keys(category.subWidgets) : [];

                            return (
                                <rmd.MenuItem
                                    key={category.name}
                                    primaryText={category.name}
                                    rightIcon={<ArrowDropRight />}
                                    leftIcon={category.leftIcon || null}
                                    menuItems={(category.widgets || [])
                                        .map(wdgt => {
                                            return (
                                                <rmd.MenuItem
                                                    key={wdgt.id + '_' + category.name}
                                                    value={wdgt.id}
                                                    primaryText={wdgt.name}
                                                    onClick={e => {
                                                        if (this.props.onChange) this.props.onChange(e, wdgt);
                                                        this.setState({ opened: false });
                                                    }}
                                                />
                                            );
                                        })
                                        .concat(
                                            subWidgets.map(sw => {
                                                return (
                                                    <rmd.MenuItem
                                                        key={sw}
                                                        value={sw}
                                                        primaryText={sw}
                                                        rightIcon={<ArrowDropRight />}
                                                        menuItems={category.subWidgets[sw].map(s => {
                                                            return (
                                                                <rmd.MenuItem
                                                                    key={s.id}
                                                                    value={s.id}
                                                                    primaryText={s.name}
                                                                    onClick={e => {
                                                                        if (this.props.onChange)
                                                                            this.props.onChange(e, s);
                                                                        this.setState({ opened: false });
                                                                    }}
                                                                />
                                                            );
                                                        })}
                                                    />
                                                );
                                            }),
                                        )}
                                />
                            );
                        }

                        //when widget group have only subWidgets
                        if (category.widgets && !category.widgets.length && Object.keys(category.subWidgets).length) {
                            const subWidgets = category.subWidgets ? Object.keys(category.subWidgets) : [];

                            return (
                                <rmd.MenuItem
                                    key={category.key}
                                    primaryText={category.name}
                                    rightIcon={<ArrowDropRight />}
                                    leftIcon={category.leftIcon || null}
                                    menuItems={subWidgets.map(sw => {
                                        return (
                                            <rmd.MenuItem
                                                key={sw}
                                                value={sw}
                                                primaryText={sw}
                                                rightIcon={<ArrowDropRight />}
                                                menuItems={category.subWidgets[sw].map(s => {
                                                    return (
                                                        <rmd.MenuItem
                                                            key={s.id}
                                                            value={s.id}
                                                            primaryText={s.name}
                                                            onClick={e => {
                                                                if (this.props.onChange) this.props.onChange(e, s);
                                                                this.setState({ opened: false });
                                                            }}
                                                        />
                                                    );
                                                })}
                                            />
                                        );
                                    })}
                                />
                            );
                        }
                    })}
                </rmd.Menu>
            </rmd.Popover>
        );
    }

    render() {
        return (
            <div className="wdp-toolbar">
                <Wrapper>
                    {this.renderLabel()}
                    {this.renderMenu()}
                </Wrapper>
            </div>
        );
    }
}

export default WidgetNestedMenu;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/WidgetNestedMenu.js
 **/